import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const skipcashBlue = "#1e3f91";

export const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(skipcashBlue),
  backgroundColor: skipcashBlue,
  color: "white",
  textTransform: "capitalize",
  fontStyle: "Poppins",

  "&:hover": {
    backgroundColor: "white",
    borderColor: skipcashBlue,
    borderWidth: 1,
    borderStyle: "solid",
    color: skipcashBlue,
    textTransform: "capitalize",
    fontStyle: "Poppins",
  },
}));
